module.exports = __webpack_public_path__ + "img/credit_grey_icon.5d780ba2.svg";